import React from "react";
import { View, Text } from "react-native";
import MaterialIcon from "@expo/vector-icons/MaterialCommunityIcons";
import TimeDisplay from "../TimeTracking/TimeDisplay";

interface Props {
  elapsedTime: number;
  activeTime: number;
  breakTime: number;
  weeklyTime?: string;
}

const TimeCard: React.FC<Props> = ({
  elapsedTime,
  activeTime,
  breakTime,
  weeklyTime = "0.0",
}) => {
  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-US", {
    weekday: "long",
    day: "numeric",
    month: "short",
  });
  const formatTime = (seconds: number) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
  
    // Pad with zeros if needed
    const paddedHrs = hrs.toString().padStart(2, '0');
    const paddedMins = mins.toString().padStart(2, '0');
    const paddedSecs = secs.toString().padStart(2, '0');
  
    return `${paddedHrs}:${paddedMins}:${paddedSecs}`;
  };

  return (
    <View className="mb-4">
      <Text className="text-2xl text-gray-800 mb-2 font-bold">
        Today, {formattedDate}
      </Text>

      <View className="bg-gray-800 p-6 rounded-2xl flex flex-row items-center justify-between pb-11 relative">
        <View>
          <Text className="text-white text-lg font-semibold mb-1">
            Total time
          </Text>
          <Text className="text-green-400 text-2xl font-bold mb-3">

            {formatTime(elapsedTime)}
          </Text>

          <View className="flex-row space-x-6 gap-2">
            <View className="flex-row items-center space-x-1 gap-1">
              <View className="w-2.5 h-2.5 rounded-full bg-green-400" />
              <Text className="text-white text-sm font-medium">Active:</Text>
              <Text className="text-white text-sm ml-1">{formatTime(activeTime)}</Text>
            </View>

            <View className="flex-row items-center space-x-1 gap-1">
              <View className="w-2.5 h-2.5 rounded-full bg-orange-400" />
              <Text className="text-white text-sm font-medium">Break:</Text>
              <Text className="text-white text-sm ml-1">{formatTime(breakTime)}</Text>
            </View>
          </View>
        </View>

        <MaterialIcon name="clock-outline" size={40} color="white" />

        <View className="absolute bottom-0 w-full bg-gray-700 left-0 rounded-2xl p-1 pl-6 pr-6">
          <Text className="text-white text-sm"><Text className="font-medium">Week Time:</Text> <Text className="text-green-400 font-bold ">{weeklyTime}</Text> hours in total</Text>
          </View>
      </View>
      
    </View>
  );
};

export default TimeCard;
